import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaHeadphones } from "react-icons/fa";
import logo from "../../Assets/Company_Logo.png";
import "./navbar2.css";

const HomeNav = ({ linksList }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);

  const navigate = useNavigate();

  const isMobile = window.innerWidth <= 900;

  /* ================= SCROLL LOGIC ================= */
  useEffect(() => {
    // if (isMobile) {
    //   setVisible(true); // 📱 always visible
    //   return;
    // }

    const onScroll = () => {
      const y = window.scrollY;

      setScrolled(y > 20);

      // 💻 ALL PAGES SAME BEHAVIOR
      if (y <= 10) {
        setVisible(true);   // top
      } else {
        setVisible(false);  // scroll down
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isMobile]);

  /* ================= BODY LOCK (MOBILE MENU) ================= */
  useEffect(() => {
    if (!isMobile) return;
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen, isMobile]);

  /* ================= NAVIGATION ================= */
  const scrollToSection = (id) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
    setMenuOpen(false);
  };

  return (
    <>
      {/* ================= HOVER ZONE (DESKTOP ONLY) ================= */}
      {!isMobile && !menuOpen && (
        <div
          className="nav-hover-zone"
          onMouseEnter={() => setVisible(true)}
        />
      )}

      {/* ================= NAVBAR ================= */}
      <nav
        className={`new-navbar ${
          menuOpen ? "hidden-nav" : visible ? "visible" : "hidden-nav"
        } ${scrolled ? "scrolled" : ""}`}
      >
        {/* BRAND */}
        <NavLink to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Logo" className="brand-logo" />
          <span className="brand-name">Valsco Technology</span>
        </NavLink>

        {/* DESKTOP LINKS */}
        {!isMobile && (
          <ul className="nav-center">
            {linksList.map((item, i) => (
              <li key={i} className="nav-li">
                {item.type === "Link" ? (
                  <span
                    className="nav-link"
                    onClick={() => scrollToSection(item.link)}
                  >
                    {item.title}
                  </span>
                ) : (
                  <NavLink
                    to={item.link}
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "activated" : ""}`
                    }
                  >
                    {item.title}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        )}

        {/* RIGHT */}
        <div className="nav-right">
          {!isMobile && (
            <span
              className="contact-btn"
              onClick={() => scrollToSection("contactuspage")}
            >
              <FaHeadphones />
              Contact
            </span>
          )}

          {/* MOBILE TOGGLE */}
          {isMobile && (
            <button
              className="menu-toggle"
              onClick={() => setMenuOpen(true)}
            >
              <FaBars />
            </button>
          )}
        </div>
      </nav>

      {/* ================= MOBILE MENU ================= */}
      {isMobile && (
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <div className="mobile-menu-inner">
            <button
              className="mobile-close"
              onClick={() => setMenuOpen(false)}
            >
              <FaTimes />
            </button>

            <ul className="mobile-links">
              {linksList.map((item, i) => (
                <li key={i}>
                  {item.type === "Link" ? (
                    <span
                      onClick={() => {
                        scrollToSection(item.link);
                        setMenuOpen(false);
                      }}
                    >
                      {item.title}
                    </span>
                  ) : (
                    <NavLink
                      to={item.link}
                      onClick={() => setMenuOpen(false)}
                    >
                      {item.title}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>

            <button
              className="mobile-contact"
              onClick={() => {
                scrollToSection("contactuspage");
                setMenuOpen(false);
              }}
            >
              <FaHeadphones />
              Contact
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeNav;